import DatePickerField from "../../common/DatePickerField ";
import Input from "../../common/Input";
import SelectForm from "../../common/SelectForm";
import TextEditorNormal from "../../common/textEditor";
import CurrencyInputField from "../../common/CurrencyInputField";

const UpdateTourFormSecondStep = ({
  formik,
  PackagePublishState,
  descriptionValue,
  DateValueValue,
}) => {
  return (
    <>
      <div className="flex w-1/2 md:w-1/3 px-3">
        <Input
          formik={formik}
          name="Load"
          label="ظرفیت"
          type="number"
          reqiuerd={true}
        />
      </div>
      <div className="flex w-1/2 md:w-1/3 px-3">
        <SelectForm
          formik={formik}
          name="State"
          label="وضعیت"
          options={PackagePublishState}
          reqiuerd={true}
        />
      </div>
      <div className="flex w-1/2 md:w-1/3 px-3">
        <CurrencyInputField
          formik={formik}
          name="AdultPrice"
          label="قیمت بزرگسال"
          type="text"
          reqiuerd={true}
        />
      </div>
      <div className="flex w-1/2 md:w-1/3 px-3">
        <CurrencyInputField
          formik={formik}
          name="ChildPrice"
          label="قیمت کودک"
          type="text"
          reqiuerd={true}
        />
      </div>

      <div className="flex w-full md:w-1/3 px-3">
        <DatePickerField
          label="تاریخ برگزاری"
          formik={formik}
          name="DateTime"
          disabled={DateValueValue?.length > 0 ? true : false}
          hasToolTip={true}
          tooltipText={
            DateValueValue?.length > 0
              ? "امکان ویرایش تاریخ وجود ندارد. برای تغییر تاریخ، لطفا این قیمت گذاری را غیر فعال و قیمت گذاری دیگری را اضافه نمایید."
              : "لطفا در نظر داشته باشید پس از ذخیره قیمت گذاری، امکان تغییر تاریخ وجود نخواهد داشت."
          }
          reqiuerd={true}
        />
      </div>
      <div className="flex w-full px-3">
        <TextEditorNormal
          label="توضیحات"
          formik={formik}
          name="Description"
          descriptionValue={descriptionValue}
        />
      </div>
    </>
  );
};

export default UpdateTourFormSecondStep;
